
export interface IPoint<TValue = number> {
    x: TValue;
    y: TValue;
}

export interface IRect<TValue = number> {
    x: TValue;
    y: TValue;
    width: TValue;
    height: TValue;
}

export interface IBounds<TValue = IPoint> {
    tl: TValue;
    tr: TValue;
    bl: TValue;
    br: TValue;
}

export interface ISize {
    width: number;
    height: number;
}


export interface IMinMax {
    min: IPoint;
    max: IPoint;
}

export function boundsRect(bounds: IBounds): IRect {
    return minMaxRect(boundsMinMax(bounds));
}


export function minMaxRect(value: IMinMax): IRect {
    if (!value)
        return null;

    return {
        x: value.min.x,
        y: value.min.y,
        width: value.max.x - value.min.x,
        height: value.max.y - value.min.y
    }
}

export function boundsMinMax(bounds: IBounds): IMinMax {
    return pointsMinMax(bounds.bl, bounds.br, bounds.tl, bounds.tr);
}


export function pointsMinMax(...points: IPoint[]): IMinMax {

    const result: IMinMax = {
        min: { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY },
        max: { x: Number.NEGATIVE_INFINITY, y: Number.NEGATIVE_INFINITY }
    }

    for (const point of points) {
        result.min.x = Math.min(result.min.x, point.x);
        result.min.y = Math.min(result.min.y, point.y);
        result.max.x = Math.max(result.max.x, point.x);
        result.max.y = Math.max(result.max.y, point.y);
    }

    return result;
}

export function subPoints(a: IPoint, b: IPoint): IPoint {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    }
}

export function pointDistance(a: IPoint, b: IPoint) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
}

export function pointEquals(a: IPoint, b: IPoint, eps = Number.EPSILON) {
    return a == b || (Math.abs(a.x - b.x) <= eps && Math.abs(a.y - b.y) <= eps)
}